export const PODIUM_STYLES = {
  1: {
    bgColor: 'var(--color-primary60)',
    height: '140px',
  },
  2: {
    bgColor: 'var(--color-primary70)',
    height: '90px',
  },
  3: {
    bgColor: 'var(--color-primary70)',
    height: '70px',
  },
  null: {
    bgColor: 'var(--color-neutral20)',
  },
};
